<template>
  <div class="cartsave-list">
    <template v-if="carts.length > 0">
      <div v-for="(cart) in carts" :id="'accordion_'+cart.id" class="accordion">
      <template v-if="cart.cart_variations.length > 0">
          <div
            :id="'heading_'+cart.id" data-toggle="collapse"
            :data-target="'#collapse_'+cart.id"
            aria-expanded="false"
            :aria-controls="'collapse_'+cart.id"
            class="white-bg container-clickable border collapsed"
            @click="loadData(cart)"
            :class="[cartMode ? 'py-1' : 'py-3']">
            <div class="d-flex flex-wrap position-relative">
              <div class="col-1 d-lg-flex align-items-center justify-content-center">
                <i class="fa fa-chevron-down"></i>
              </div>
              <template v-if="cartMode==='slideIn'">
                <div class="col-8">
                  {{ $translate("CartSave::Template.cartAccordionName") }} <br>
                  <b>{{ cart.cart_name }}</b>
                </div>
                <div class="col-3 text-right align-items-center d-flex justify-content-end">
                  <template v-if="items.length > 0 || Object.keys(item).length > 0">
                    <button class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <template v-if="cart.addedBtnLoading">
                        <i class="fa fa-spin fa-circle-o-notch "></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-plus "></i>
                      </template>
                    </button>
                  </template>
                  <template v-else>
                    <button class="btn btn-primary" @click="showShare(cart);$event.stopPropagation()">
                      <i class="fa fa-share-alt" aria-hidden="true"></i>
                    </button>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="col-lg-3 col-9 text-left" :class="[editable ? 'col-lg-5' : 'col-lg-3']">
                  {{ $translate("CartSave::Template.cartAccordionName") }} <br>
                  <b>{{ cart.cart_name }}</b>
                </div>
                <div class="offset-1 col-2 d-flex d-lg-none justify-content-end align-items-center">
                  <i class="fa fa-chevron-down"></i>
                </div>
                <div class="col-lg-3 d-none d-lg-block col-9 text-left">
                  {{  $translate("CartSave::Template.cartAccordionDateAdd") }}
                  <br>
                  <b>{{ cart.cart_createdAt * 1000 | date($translate("Ceres::Template.devDateFormatMoment") || "DD.MM.YYYY")  }}</b>
                </div>
                <div class="col-lg-3 d-block d-lg-none col-9 text-left">
                  {{ $translate("CartSave::Template.cartAccordionDateChange") }}
                  {{ cart.cart_updatedAt * 1000 | date($translate("Ceres::Template.devDateFormatMoment") || "DD.MM.YYYY") }}
                </div>
                <div class="d-lg-block d-none col-lg-3 col-9 text-left">
                  {{  $translate("CartSave::Template.cartAccordionDateChange") }}
                  <br>
                  <b>{{ cart.cart_updatedAt * 1000 | date($translate("Ceres::Template.devDateFormatMoment") || "DD.MM.YYYY") }}</b>
                </div>
                <template v-if="!editable">
                  <div class="col-3 d-sm-block d-lg-none mt-2 text-right pr-0" >
                    <button class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <template v-if="cart.addedBtnLoading">
                        <i class="fa fa-spin fa-circle-o-notch "></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-plus "></i>
                      </template>
                    </button>
                  </div>
                  <div class="col-lg-1 offset-lg-1 d-none d-lg-block text-center mt-0 pr-0" >
                    <button  class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <template v-if="cart.addedBtnLoading">
                        <i class="fa fa-spin fa-circle-o-notch "></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-plus "></i>
                      </template>
                    </button>
                  </div>
                </template>
              </template>
              <template v-if="cartMode==='slideIn'">
                <div class="d-flex share-buttons" :class="{'show' : cart.showShare }">
                  <div class="col-3">
                    <template v-if="cart.cart_isPublic == false">


                      <a class="btn btn-default w-100"
                         @click="cart.cart_isPublic = true; updateCart(cart); $event.stopPropagation()"
                         :title="$translate('CartSave::Template.cartLocked')"
                         v-tooltip
                         :aria-label="$translate('CartSave::Template.cartLocked')"
                         data-toggle="tooltip"
                         data-placement="top">
                          <i class="fa fa-lock float-none" aria-hidden="true"></i>
                      </a>
                    </template>
                    <template v-else>
                      <a class="btn btn-default w-100"
                         @click="cart.cart_isPublic = false; updateCart(cart); $event.stopPropagation()"
                         :title="$translate('CartSave::Template.cartUnlocked')"
                         :aria-label="$translate('CartSave::Template.cartUnlocked')"
                         v-tooltip
                         data-toggle="tooltip"
                         data-placement="top">
                        <i class="fa fa-unlock float-none" aria-hidden="true"></i>
                      </a>
                    </template>
                  </div>
                  <div class="col-3">
                    <a @click="cart.cart_isPublic = true; updateCart(cart); copyUrlToClipboard(cart.url); $event.stopPropagation()"
                       class="btn btn-default w-100"
                       :disabled="cart.cart_isPublic == false"
                       :title="$translate('CartSave::Template.cartClipboard')"
                       v-tooltip
                       data-toggle="tooltip"
                       data-placement="top">
                      <i class="fa fa-clipboard float-none" aria-hidden="true"></i>
                    </a>
                  </div>
                  <div class="col-3">
                    <a :href="$translate('CartSave::Template.cartWATo',{url:cart.url})"
                       @click="cart.cart_isPublic = true; updateCart(cart);$event.stopPropagation()"
                       :disabled="cart.cart_isPublic == false"
                       :class="{'WAactive': cart.cart_isPublic == true}"
                       class="btn btn-whatsapp btn-default w-100"
                       :aria-label="$translate('CartSave::Template.cartWhatsapp')"
                       :title="$translate('CartSave::Template.cartWhatsapp')"
                       v-tooltip
                       data-toggle="tooltip"
                       data-placement="top">
                      <i  class="fa fa-whatsapp float-none"></i>
                    </a>
                  </div>
                  <div class="col-3">
                    <a :href="$translate('CartSave::Template.cartMailTo',{documentLocation:docLocation,url:cart.url})"
                       @click="cart.cart_isPublic = true; updateCart(cart);$event.stopPropagation()"
                       :disabled="cart.cart_isPublic == false"
                       :class="{'EmailActive': cart.cart_isPublic == true}"
                       class="btn btn-default w-100"
                       :title="$translate('CartSave::Template.cartMail')"
                       :aria-label="$translate('CartSave::Template.cartMail')"
                       v-tooltip
                       data-toggle="tooltip"
                       data-placement="top">
                      <i class="fa fa-envelope-o float-none"></i>
                    </a>
                  </div>
                </div>
              </template>
            </div>
        </div>
      </template>
      <template v-else>
          <div
            :id="'heading_'+cart.id"
            data-toggle="collapse"
            :data-target="'#collapse_'+cart.id"
            aria-expanded="false"
            :aria-controls="'collapse_'+cart.id"
            class="white-bg container-clickable border collapsed"
            @click="cart.open = cart.open === false; $store.dispatch('updateCartData',cart)"
            :class="[cartMode ? 'py-1' : 'py-3']">
            <div class="d-flex flex-wrap">
              <template v-if="cartMode==='slideIn'">
                <div class="col-lg-1 d-lg-flex align-items-center justify-content-center">
                  <i class="fa fa-chevron-down"></i>
                </div>
                <div class="col-8">
                  {{ $translate("CartSave::Template.cartAccordionName") }} <br>
                  <b>{{ cart.cart_name }}</b>
                </div>
                <div class="col-3 text-right align-items-center d-flex justify-content-end">
                  <template v-if="items.length > 0 || Object.keys(item).length > 0">
                    <button class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <template v-if="cart.addedBtnLoading">
                        <i class="fa fa-spin fa-circle-o-notch "></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-plus "></i>
                      </template>
                    </button>
                  </template>
                  <template v-else>
                    <button class="btn btn-primary" @click="showShare(cart);$event.stopPropagation()">
                      <i class="fa fa-share-alt" aria-hidden="true"></i>
                    </button>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="col-lg-3  col-9 text-left">
                  {{ $translate("CartSave::Template.cartAccordionName") }}
                  <br>
                  <b>{{ cart.cart_name }}</b>
                </div>
                <div class="offset-1 col-2 d-flex d-lg-none justify-content-end align-items-center">
                  <i class="fa fa-chevron-down"></i>
                </div>
                <div class="col-lg-3 d-none d-lg-block col-9 text-left">
                  {{  $translate("CartSave::Template.cartAccordionDateAdd") }}
                  <br>
                  <b>{{ cart.cart_createdAt | date('d.m.Y') }}</b>
                </div>
                <div class="col-lg-3 d-block d-lg-none col-9 text-left">
                  {{ $translate("CartSave::Template.cartAccordionDateChange") }}
                  {{ cart.cart_updatedAt | date('d.m.Y') }}
                </div>
                <div class="d-lg-block d-none col-lg-3 col-9 text-left">
                  {{  $translate("CartSave::Template.cartAccordionDateChange") }}
                  <br>
                  <b>{{ cart.cart_updatedAt | date('d.m.Y') }}</b>
                </div>
                <template v-if="!editable">
                  <div class="col-3 d-sm-block d-lg-none mt-2 text-right pr-0" >
                    <button class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <i class="fa fa-plus "></i>
                    </button>
                  </div>
                  <div class="col-lg-1 offset-lg-1 d-none d-lg-block text-center mt-0 pr-0" >
                    <button  class="btn btn-primary" @click="addToCart(cart);$event.stopPropagation()">
                      <i class="fa fa-plus "></i>
                    </button>
                  </div>
                </template>
              </template>
            </div>
          </div>
      </template>
      <div
          :id="'collapse_'+cart.id"
          class="collapse white-bg col-12 border-left border-bottom border-right position-relative include-waiting px-0">
          <div class="cart-loading" v-if="cart.loading">
            <i class="fa fa-spin fa-circle-o-notch"></i>
          </div>
          <template v-else>
            <template v-if="cart.cart_variations.length > 0">
              <template v-if="editable">
                <div class="cart-head border-bottom">
                  <div class="d-block d-lg-flex w-100 ybbCartHeader align-items-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="form-group form-check my-3 col-4 col-md-2 col-lg-3 d-flex publicCheckboxes align-items-center">
                        <input type="checkbox" class="mr-2" :id="'publicCart'+cart.id" v-model="cart.cart_isPublic" @change="updateCart(cart)">
                        <label class="form-check-label" :for="'publicCart'+cart.id">
                          <i class="fa fa-share" aria-hidden="true"></i>{{  $translate("CartSave::Template.cartDoPublic") }}
                        </label>
                      </div>
                      <div class="d-flex col-4 col-md-6 col-lg-6">
                        <div class="form-group publicUrlWrapper" v-if="cart.cart_isPublic == true">
                          <div disabled type="text" ref="copyPublicUrl" @click=copyUrlToClipboard(cart.url) class="form-control CartSavePublicUrl" :value="cart.url" >
                            <i class="fa fa-clipboard mr-2" aria-hidden="true"></i>
                            <span class="d-none d-md-inline">
                                {{ cart.url}}
                            </span>
                            <span class="d-sm-inline d-md-none">
                                Link
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group shareButtons justify-content-end d-flex  col-md-4 col-lg-3 col-4  my-3">
                        <a :href="$translate('CartSave::Template.cartMailTo',{documentLocation:docLocation,url:cart.url})"
                           v-tooltip="true" data-html="true" data-toggle="tooltip" data-placement="top"
                           :aria-label="$translate('CartSave::Template.cartMailTo')"
                           :class="{'EmailActive': cart.cart_isPublic == true}" class="btn btn-default mr-2">
                          <i class="fa fa-envelope-o"></i>
                        </a>
                        <a :aria-label="$translate('CartSave::Template.cartWATo')" :href="$translate('CartSave::Template.cartWATo',{url:cart.url})" v-tooltip="true" data-html="true" data-toggle="tooltip" data-placement="top" :disabled="cart.cart_isPublic == false" :class="{'WAactive': cart.cart_isPublic == true}" class="btn btn-whatsapp btn-default">
                          <i  class="fa fa-whatsapp"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </template>
              <cs-list-items :cart="cart" :editable="editable" :cart-mode="cartMode" :delete-items-from-list="deleteItemsFromList"></cs-list-items>
              <template v-if="editable">
                <div class="col-lg-12 pt-2 pb-2 ybb-cart-btns">
                <div class="row mt-2">
                  <div class="col-lg-3 text-left">
                    <button :disabled="cart.waiting || cart.items.length < 1" class="btn btn-block btn-primary d-inline-block" @click="addToBasket({},cart)">
                      {{  $translate("CartSave::Template.cartAdd") }}
                    </button>
                    <div>
                      <label :for="'cartDeleteCurrentBasket_'+cart.id" class="mb-0 mt-2 align-items-center d-flex">
                        <input type="checkbox" required="required" :id="'cartDeleteCurrentBasket_'+cart.id" v-model="cart.deleteBasketFirst" class="mr-2">
                        {{ $translate("CartSave::Template.cartDeleteCurrentBasket") }}
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-3 offset-lg-6 mt-2 mt-lg-0">
                    <div>
                      <button class="btn btn-block btn-danger" @click="deleteCartBtn(cart)">
                        {{ $translate("CartSave::Template.cartDeleteCart") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </template>
              <template v-if="cartMode ==='slideIn'">
                <div class="d-flex w-100 p-3" style="margin-top:-1px;">
                  <div class="flex-fill mr-3">
                    <div class="btn btn-outline-primary btn-block" @click="editMode(cart)">
                      <template v-if="cart.editMode === false">
                        <i class="fa fa-pencil"></i>
                        Bearbeiten
                      </template>
                      <template v-else>
                        <i class="fa fa-check"></i>
                        Speichern
                      </template>
                    </div>
                  </div>
                  <div>
                    <div class="btn btn-secondary" @click="deleteList(cart)">
                      <i class="fa fa-trash-o pl-3"></i>
                      Liste löschen
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="cart-item p-3 align-items-center col-12 text-center">
                {{ $translate("CartSave::Template.cartNoItems") }}
              </div>
              <template v-if="cartMode ==='slideIn'">
                <div class="d-flex w-100 p-3" style="margin-top:-1px;">
                  <div class="flex-fill mr-3">
                    <div class="btn btn-secondary btn-block" @click="deleteList(cart)">
                      <i class="fa fa-trash-o pl-3"></i>
                      {{ $translate("CartSave::Template.cartDeleteCart") }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="emptycarts">
        {{ $translate("CartSave::Template.cartEmptyCart") }}
      </template>
      <template v-else>
        <div class="text-center">
          <i class="fa fa-spin fa-circle-o-notch fa-2x"></i>
        </div>
      </template>
    </template>
    <div class="modal fade deleteList" id="deleteList" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" >
          <div class="modal-header">
            <div class="modal-title h3 w-100">
              {{  $translate("CartSave::Template.cartDeleteCart") }}
            </div>
            <button type="button" class="close btn-primary" ref="closeBtn" data-dismiss="modal" aria-hidden="true" >&times;</button>
          </div>
          <div class="modal-body p-3 px-5" v-if="deleteCartData">
            <h4>{{  $translate("CartSave::Template.myAccountDeleteCart") }}  "{{ deleteCart.cart_name }}" </h4>
            <div class="row mt-4 mb-2">
              <div class="col-6 d-flex justify-content-start">
                <button class="btn btn-danger btn-primary btn-appearance btn-md" @click="deleteThisCart()" :aria-label="$translate('CartSave::Template.cartDeleteCart')">
                  {{  $translate("CartSave::Template.cartDeleteCart") }}
                </button>
              </div>
              <div class="col-6 d-flex justify-content-end">
                <button class="btn btn-primary btn-appearance btn-md" ref="close" data-dismiss="modal" :aria-label="$translate('CartSave::Template.myAccountCloseBtn')">
                  {{  $translate("CartSave::Template.myAccountCloseBtn") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import csListItems  from "./CsListItems.vue"
import {mapState}   from "vuex";

export default
{
  name: "CsList",
  props:
  {
    deleteItemsFromList:
    {
        type    : String,
        default : "false"
    },
    isPublic:
    {
        type    : Boolean,
        default : false
    },
    editable:
    {
      type      : Boolean,
      default   : false
    },
    carts:
    {
      type      : Array,
      default   : []
    },
    cartMode:
    {
      type      : String,
      default   : ""
    }
  },
  components:{csListItems},
  data ()
  {
    return {
      isLoading : false,
      deleteCart:null
    }
  },
  methods:
  {
    formatNumberToQuantity(number)
    {
      if(Number.isInteger(number))
      {
        return number;
      }
      else
      {
        return number.toFixed(1)
      }

    },
    deleteList(cart)
    {
      this.$store.dispatch('deleteThisCart',cart)
    },
    showShare(cart)
    {
      if(cart.showShare === false)
      {
        cart.showShare = true;
      }
      else
      {
        cart.showShare = false;
      }
    },
    editMode(cart)
    {
      if(cart.editMode === false)
      {
        cart.editMode = true;
      }
      else
      {
        this.$store.dispatch('updateCart',cart)
        cart.editMode = false;
      }

    },
    deleteThisCart()
    {
      return this.$store.dispatch('deleteThisCart',this.deleteCart)
    },
    deleteCartBtn(cart)
    {
      this.deleteCart = cart;
      $('#deleteList').modal('show');
    },
    copyUrlToClipboard(url)
    {
      navigator.clipboard.writeText(url);
      CeresNotification.success(ceresTranslate("CartSave::Template.notesInDieZwischenAblage")).closeAfter(3000);
    },
    updateCart(cart)
    {
      return this.$store.dispatch('updateCart',cart)
    },
    deleteItem(cartid,itemid)
    {
      this.$store.dispatch('removeItemFromList',{ "cartid": cartid, "itemid": itemid } );
    },
    updateQuantity(item,cart,operator = null)
    {
      if (operator == null)
      {
        if (item.quantity >= item.data.variation.minimumOrderQuantity)
        {
          return this.$store.dispatch('updateCart',cart)
        }
        else
        {
          item.quantity = parseFloat(this.formatNumberToQuantity(item.data.variation.minimumOrderQuantity));
          return this.$store.dispatch('updateCart',cart)
        }
      }
      else
      {
        if (operator === '+')
        {
          item.quantity = parseFloat(this.formatNumberToQuantity((item.quantity + item.data.variation.intervalOrderQuantity)));
          return this.$store.dispatch('updateCart',cart)
        }
        else
        {
          let newQuantity = parseFloat(this.formatNumberToQuantity((item.quantity - item.data.variation.intervalOrderQuantity)));
          if(newQuantity >= item.data.variation.minimumOrderQuantity)
          {
            item.quantity = newQuantity;
          }
          else
          {
            item.quantity = this.formatNumberToQuantity(item.data.variation.minimumOrderQuantity)
          }
          return this.$store.dispatch('updateCart',cart)
        }
      }
    },
    addToBasket(item = {},cart)
    {
      let data = { "items":[] };
      if(Object.keys(item).length > 0)
      {
        item.cartloading = true;
        data.items.push({"variationId":item.id,"quantity":item.quantity,"name":item.data.texts.name1});
      }
      else
      {
        for(let i = 0; i < cart.items.length; i++)
        {
          cart.waiting = true;
          if(cart.deleteBasketFirst)
          {
            data.deleteBasketFirst = true;
          }
          if(cart.items[i].data.filter.isSalableAndActive === true)
          {
            data.items.push({
              "variationId" : cart.items[i].id,
              "quantity"    : cart.items[i].quantity,
              "name"        : cart.items[i].data.texts.name1
            });
          }
        }
      }

      $.ajax({
        type: 'POST',
        url: '/rest/cartsave/basket/addToBasket/',
        data: data,
        success: function (data)
        {
          (Object.keys(item).length == 0) ? cart.waiting = false : item.cartloading = false;
          for( let i = 0; i < data.length; i++)
          {
            cart.deleteBasketFirst = false;
            if(data[i].error)
            {
              if(data[i].error.placeholder && data[i].error.placeholder.stock)
              {
                CeresNotification.error(ceresTranslate("CartSave::Template.notesNichtgenugbestand",
                    {
                      variationName: data[i].error.variationName,
                      stock: data[i].error.placeholder.stock
                    })
                );
              }

            }
            else
            {
              cart.deleteBasketFirst = false;
              CeresNotification.success(ceresTranslate("CartSave::Template.notesArtikelhinzugefuegt")).closeAfter(3000);
            }
            if(i === data.length-1)
            {
              vueApp.$store.commit("setBasketItems", data[i].basketItems);
              vueApp.$store.commit("setBasket", data[i].basket);
            }
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          cart.deleteBasketFirst = false;
          (Object.keys(item).length == 0) ? cart.waiting = false : item.cartloading = false;
          console.log('error',jqXHR,textStatus,errorThrown)
        }
      });
    },
    addToCart(cart)
    {
      this.$store.dispatch('addToItemToList',cart)
    },
    loadData(cart)
    {
      cart.open = cart.open === false;
      this.$store.dispatch('updateCartData',cart)
      if(cart.items.length === 0 && cart.cart_variations.length > 0)
      {
        cart.loading = true;
        $.ajax({
          type: 'POST',
          url: '/rest/cartsave/cart/itemData/',
          data:{"vars":cart.cart_variations},
          success: function (data)
          {
            cart.loading = false;
            for(let i = 0; i < data.length; i++)
            {
              data[i].cartloading = false;
            }
            cart.items   = data;
          },
          error: function (jqXHR, textStatus, errorThrown)
          {
            cart.loading = false;
            console.error(errorThrown)
          }
        })
      }
    }
  },
  computed:
  {
    deleteCartData()
    {
      return this.deleteCart
    },
    docLocation()
    {
      return window.origin.split('.')[1];
    },
    ...mapState({
      emptycarts: state => state.cartsave.emptycarts,
      item: state => state.cartsave.item,
      items: state => state.cartsave.items
    })
  }

}
</script>

